import { render } from "./toolbar.vue?vue&type=template&id=6bdd6446&scoped=true&ts=true"
import script from "./toolbar.vue?vue&type=script&lang=ts"
export * from "./toolbar.vue?vue&type=script&lang=ts"

import "./toolbar.vue?vue&type=style&index=0&id=6bdd6446&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bdd6446"]])

export default __exports__